// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { encodeFilters } from "@/lib/filter-params";
import { getDefaultPageSize } from "@/lib/preferences";

/**
 * The Stores list's URL filter state (`?f=`), and its defaults. Lives apart from the page so other
 * pages can deep-link into a filtered list via `storesListSearch` without importing the page.
 */
export const STORES_FILTER_DEFAULTS = {
  search: "",
  onlyActive: true,
  chain: "",
  region: "",
  page: 0,
  get pageSize() {
    return getDefaultPageSize();
  },
  sortId: "legibleName",
  sortDesc: false,
  // Appended, never reordered: `decodeFilters` keys a URL's value array off this key order, so an
  // insertion in the middle would silently reinterpret every link already in someone's bookmarks.
  goLiveOption: "",
  goLiveFrom: "",
  goLiveTo: "",
  installOption: "",
  installFrom: "",
  installTo: "",
};

export type StoresFilters = typeof STORES_FILTER_DEFAULTS;

/** Router `search` for `/stores` showing the list with `overrides` applied over the defaults. */
export function storesListSearch(overrides: Partial<StoresFilters>): { f?: string } {
  const encoded = encodeFilters({ ...STORES_FILTER_DEFAULTS, ...overrides }, STORES_FILTER_DEFAULTS);
  return encoded ? { f: encoded } : {};
}
